module.exports = __webpack_public_path__ + "img/mini-004.c50dcfc3.jpg";